module.exports = __webpack_public_path__ + "img/roadmap.2734c3a2.svg";